// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { Component, OnInit, Input } from '@angular/core';
import { PolicyService } from '@app/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export enum RemoveResult {
  REMOVE_SUCCEEDED,
  REMOVE_FAILED,
  DISMISSED
}

@Component({
  selector: 'app-remove-policy-modal',
  templateUrl: './remove-policy-modal.component.html',
  styleUrls: ['./remove-policy-modal.component.scss']
})
export class RemovePolicyModalComponent implements OnInit {
  @Input() removedPolicyId?: string;

  constructor(
    private policyService: PolicyService,
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
  }

  close() {
    return this.activeModal.close(RemoveResult.DISMISSED);
  }

  remove() {
    if (this.removedPolicyId === undefined) {
      throw Error('Remove policy was undefined');
    }

    this.policyService.delete(this.removedPolicyId).subscribe(
      _ => {
        this.activeModal.close(RemoveResult.REMOVE_SUCCEEDED);
      },
      err => {
        this.activeModal.close(RemoveResult.REMOVE_FAILED);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/policies/policies-list/remove-policy-modal/remove-policy-modal.component.ts